import React from 'react';
import { SnackbarContent } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const styles = {
  error: {
    background: 'red',
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
};

function ErrorMessage({ errorMessage }) {
  return (
    <SnackbarContent
      style={styles.error}
      message={(
        <span id="error-message-id" style={styles.message}>
          <ErrorIcon style={styles.icon} sx={{ mr: 2 }} />
          {errorMessage}
        </span>
    )}
    />
  );
}

export default ErrorMessage;
